export default "__VITE_ASSET__9a70cf1b__"